import { Component, OnInit, ViewChild } from '@angular/core';

import * as _ from 'lodash';

import { ButtonComponent } from '../../../button/index';
import { Dialog, DialogRef, DialogParams, DialogStringFunction } from '../../../dialog/dialog.base';

/**
 * @ignore
 */
@Component({
  selector: 'uex-dialog-alert',
  templateUrl: './alert.component.html'
})
export class DialogAlertComponent implements OnInit {
  @ViewChild('button', { static: true }) private _button: ButtonComponent;

  constructor(
    private _dialogRef: DialogRef,
    private _dialogParams: DialogParams
  ) {
    this.dialog = this._dialogRef.dialog;
    if(!this.dialog.settings.keyboard) {
      this.dialog.setKeyboard({
        onEscape: () => this.close(),
        onReturn: () => this.close()
      });
    }
  }

  public dialog: Dialog;

  public get headerClass(): string {
    return this._dialogParams.get('headerClass');
  }

  public get title(): string {
    return this._dialogParams.get('title');
  }

  public get titleClass(): string {
    return this._dialogParams.get('titleClass');
  }

  public get subtitle(): string {
    return this._dialogParams.get('subtitle');
  }

  public get subtitleClass(): string {
    return this._dialogParams.get('subtitleClass');
  }

  public get message(): string {
    return this._dialogParams.get('message');
  }

  public get footerClass(): string {
    return this._dialogParams.get('footerClass');
  }

  public get buttonText(): string {
    let button_text: DialogStringFunction | string = this._dialogParams.get('buttonText');
    if(_.isFunction(button_text)) {
      button_text = (<DialogStringFunction>button_text)();
    }
    return button_text ? (<string>button_text) : 'Ok';
  }

  public get buttonMode(): string {
    let button_mode: string = this._dialogParams.get('buttonMode');
    return button_mode ? button_mode : 'clear';
  }

  public get buttonColor(): string {
    let button_color: string = this._dialogParams.get('buttonColor');
    return button_color ? button_color : 'primary';
  }

  public close() {
    this.dialog.close();
  }

  public ngOnInit() {
    if(this._button) this._button.focus(true);
  }
}
